/* SupportThanks.jsx — where Stripe sends a supporter after paying (web only).
 * Deliberately says nothing about plans or features: a Support JAI payment
 * does not change either. Stripe sends the receipt. */

import { Link } from 'react-router-dom'
import { JaiMark, JaiWordmark, JAI_COLORS, JAI_FONTS } from '../components/JaiBrand'

export default function SupportThanks() {
  return (
    <div style={{ minHeight: 'calc(100vh / var(--jai-zoom))', background: JAI_COLORS.paper, fontFamily: JAI_FONTS.tight }}>
      <div style={{ maxWidth: 520, margin: '0 auto', padding: '72px 24px', textAlign: 'center' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, marginBottom: 28 }}>
          <JaiMark size={34} />
          <JaiWordmark size={21} />
        </div>
        <h1 style={{ color: JAI_COLORS.navy, fontSize: 30, fontWeight: 800, letterSpacing: '-0.02em', margin: '0 0 12px' }}>
          Thank you
        </h1>
        <p style={{ color: JAI_COLORS.mute, fontSize: 16, lineHeight: 1.6, margin: 0 }}>
          Your support goes straight into building JAI faster. It means a lot. We'll email you a receipt
          shortly.
        </p>
        <Link to="/chat"
          style={{ display: 'inline-block', marginTop: 28, background: JAI_COLORS.blue, color: '#fff', textDecoration: 'none', borderRadius: 10, padding: '12px 22px', fontWeight: 600 }}>
          Back to JAI
        </Link>
      </div>
    </div>
  )
}
